import {createSelector, Selector} from '@reduxjs/toolkit';

import {CONTEXT_FILTER_LOOKUPS} from 'components/context-filter/context-filter.constants';
import {TAppState} from 'store/config/types';

import {CONTEXT_MODULE} from './context-constants';
import {IContextData, IContextRawData, IContextState} from './context-types';

const rootSelector: Selector<TAppState, IContextState> = (state: TAppState) => state[CONTEXT_MODULE];

export const selectContextRawData = createSelector(
    rootSelector,
    (dataState: IContextState) => dataState.rawData as IContextRawData | undefined,
);

export const selectContextLookups = createSelector(
    rootSelector,
    (dataState: IContextState) => dataState.lookups,
);

export const selectEntityNamesFetchedWithContext = createSelector(
    rootSelector,
    (dataState: IContextState) => dataState.fetchedWithContext,
);

export const selectContextDataWithLookups: Selector<TAppState, IContextData> = createSelector(
    selectContextRawData,
    selectContextLookups,
    (rawData, lookups) => {
        if (!rawData || !lookups) return {};
        const lookupsWithValues = (() => {
            const values = Object.keys(CONTEXT_FILTER_LOOKUPS).map(key => {
                const keyToPickValue = key as keyof IContextRawData;
                const id = rawData[keyToPickValue];
                const value = lookups[keyToPickValue]?.find(v => v.id === id) ?? id;
                return [keyToPickValue, value];
            });
            return Object.fromEntries(values);
        })();
        return {...rawData, ...lookupsWithValues} as IContextData;
    },
);
